/**
 * Store Locator – Leaflet map + filterable list + distance sorting
 * Reads store data from a JSON script block rendered server-side.
 * Uses browser Geolocation API + OpenStreetMap Nominatim for geocoding.
 */
(function () {
  'use strict';

  /* ── DOM refs ── */
  const root      = document.querySelector('.store-locator');
  if (!root) return;

  const dataEl    = document.getElementById('store-locator-data');
  const mapEl     = document.getElementById('storeMap');
  const listEl    = document.getElementById('storeList');
  const inputEl   = document.getElementById('storeFilter');
  const emptyEl   = document.getElementById('storeEmpty');
  const toggleEl  = document.getElementById('storeMapToggle');
  const locateBtn = document.getElementById('storeLocateBtn');
  const mapCol    = root.querySelector('.store-locator__map-col');

  if (!dataEl || !mapEl || !listEl) return;

  /* ── Parse store data ── */
  let STORES;
  try { STORES = JSON.parse(dataEl.textContent); }
  catch (e) { console.error('[Store Locator] Invalid JSON', e); return; }

  if (!STORES.length) return;

  /* ── Helpers ── */
  const normalize = (s) =>
    (s || '').toString().toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ').trim();

  function mapsLink(s) {
    const q = encodeURIComponent(
      [s.address, s.city, s.zip, s.country].filter(Boolean).join(', ')
    );
    return 'https://www.google.com/maps/search/?api=1&query=' + q;
  }

  function isMobile() {
    return window.matchMedia('(max-width: 979px)').matches;
  }

  /* ── Haversine distance (km) ── */
  function haversineKm(lat1, lon1, lat2, lon2) {
    var R = 6371;
    var dLat = (lat2 - lat1) * Math.PI / 180;
    var dLon = (lon2 - lon1) * Math.PI / 180;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  /* ── Build search index on cards ── */
  const cards = Array.from(listEl.querySelectorAll('.store-locator__card'));
  cards.forEach(function (card, i) {
    var s = STORES[i];
    if (!s) return;
    var hay = normalize([s.name, s.address, s.city, s.zip, s.phone].join(' '));
    card.setAttribute('data-search', hay);
    card.setAttribute('data-i', i);
  });

  /* ── Prevent search-input clicks from bubbling ── */
  if (inputEl) {
    ['click', 'focus', 'mousedown'].forEach(function (evt) {
      inputEl.addEventListener(evt, function (e) { e.stopPropagation(); });
    });
  }

  /* ── Leaflet map ── */
  var helsamIcon = L.divIcon({
    className: '',
    html: '<div class="store-locator__pin"></div>',
    iconSize: [28, 28],
    iconAnchor: [14, 28]
  });

  var map = L.map(mapEl, {
    zoomControl: false,
    scrollWheelZoom: false,
    doubleClickZoom: true,
    dragging: true,
    tap: true
  });

  const cartoKey = mapEl.dataset.cartoKey || '';
  const cartoTileUrl = 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png' +
    (cartoKey ? '?key=' + encodeURIComponent(cartoKey) : '');

  L.tileLayer(cartoTileUrl, {
    subdomains: 'abcd',
    maxZoom: 20,
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>'
  }).addTo(map);

  var allBounds = L.latLngBounds([]);
  var markerByIndex = new Map();

  function popupHtml(s) {
    var html = '<div style="min-width:220px">';
    html += '<strong>' + s.name + '</strong><br>';
    if (s.address) html += s.address + '<br>';
    html += [s.zip, s.city].filter(Boolean).join(' ');
    if (s.phone) html += '<br>Tlf. ' + s.phone;
    html += '<div style="margin-top:8px;display:flex;gap:10px;flex-wrap:wrap">';
    if (s.url) html += '<a href="' + s.url + '">Se butik</a>';
    html += '<a href="' + mapsLink(s) + '" target="_blank" rel="noopener">Få rute</a>';
    html += '</div></div>';
    return html;
  }

  STORES.forEach(function (s, i) {
    if (typeof s.lat !== 'number' || typeof s.lng !== 'number') return;

    var m = L.marker([s.lat, s.lng], { icon: helsamIcon })
      .addTo(map)
      .bindPopup(popupHtml(s), { autoPan: false });

    markerByIndex.set(i, m);
    allBounds.extend([s.lat, s.lng]);
  });

  if (allBounds.isValid()) map.fitBounds(allBounds, { padding: [30, 30] });
  else map.setView([56.0, 10.0], 6);

  /* ── User location marker ── */
  var userMarker = null;

  function showUserMarker(lat, lng) {
    if (userMarker) map.removeLayer(userMarker);
    var icon = L.divIcon({
      className: '',
      html: '<div style="width:12px;height:12px;border-radius:50%;background:#3b82f6;border:3px solid #fff;box-shadow:0 0 0 2px rgba(59,130,246,0.4),0 2px 8px rgba(0,0,0,0.2)"></div>',
      iconSize: [18, 18],
      iconAnchor: [9, 9]
    });
    userMarker = L.marker([lat, lng], { icon: icon, interactive: false }).addTo(map);
  }

  /* ── Auto-fit suppression ── */
  var suppressUntil = 0;
  var selectedIndex = null;

  function suppressAutoFit(ms) { suppressUntil = Date.now() + (ms || 800); }
  function canAutoFit() { return Date.now() > suppressUntil; }

  function fitDefaultView() {
    if (!canAutoFit() || selectedIndex !== null) return;

    var q = inputEl ? normalize(inputEl.value) : '';

    if (!q && allBounds.isValid()) {
      map.fitBounds(allBounds, { padding: [30, 30] });
      return;
    }

    var visible = L.latLngBounds([]);
    cards.forEach(function (card) {
      if (card.hidden) return;
      var m = markerByIndex.get(Number(card.dataset.i));
      if (m) visible.extend(m.getLatLng());
    });

    if (visible.isValid()) map.fitBounds(visible, { padding: [30, 30] });
    else if (allBounds.isValid()) map.fitBounds(allBounds, { padding: [30, 30] });
  }

  /* ── Mobile map toggle ── */
  function setMapOpen(open) {
    if (!mapCol || !toggleEl) return;
    mapCol.classList.toggle('is-open', open);
    toggleEl.setAttribute('aria-expanded', open ? 'true' : 'false');
    toggleEl.textContent = open ? 'Skjul kort' : 'Vis på kort';

    if (open) {
      setTimeout(function () {
        map.invalidateSize(true);
        fitDefaultView();
        mapCol.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 60);
    }
  }

  if (toggleEl && mapCol) {
    if (isMobile()) setMapOpen(false);

    toggleEl.addEventListener('click', function () {
      setMapOpen(!mapCol.classList.contains('is-open'));
    });
  }

  /* ── Resize handler ── */
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      if (!isMobile()) {
        mapCol && mapCol.classList.add('is-open');
        map.invalidateSize(true);
        fitDefaultView();
      } else if (mapCol && mapCol.classList.contains('is-open')) {
        map.invalidateSize(true);
        fitDefaultView();
      }
    }, 150);
  });

  /* ── Card click → zoom ── */
  listEl.addEventListener('click', function (e) {
    if (e.target.closest('a')) return;
    var card = e.target.closest('.store-locator__card');
    if (!card) return;

    var i = Number(card.dataset.i);
    var s = STORES[i];
    var m = markerByIndex.get(i);

    selectedIndex = i;
    suppressAutoFit(5000);

    cards.forEach(function (c) { c.classList.remove('is-active'); });
    card.classList.add('is-active');

    if (isMobile() && mapCol && toggleEl) setMapOpen(true);

    if (m && s) {
      map.setView([s.lat, s.lng], 14, { animate: true });
      m.openPopup();

      /* Scroll map into view so the user sees the centered pin */
      if (mapEl) {
        setTimeout(function () {
          mapEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }, 100);
      }
    }
  });

  /* ═══════════════════════════════════════════════════════════
     Distance calculation + sorting
     ═══════════════════════════════════════════════════════════ */

  var currentUserLat = null;
  var currentUserLng = null;
  var isDistanceMode = false;

  /**
   * Calculate distances from (lat,lng), update badges, and re-sort cards.
   */
  function applyDistances(lat, lng) {
    currentUserLat = lat;
    currentUserLng = lng;
    isDistanceMode = true;

    /* Calculate distance for each store */
    STORES.forEach(function (s, i) {
      if (typeof s.lat === 'number' && typeof s.lng === 'number') {
        s._dist = haversineKm(lat, lng, s.lat, s.lng);
      } else {
        s._dist = Infinity;
      }
    });

    /* Show ALL cards and update badge text */
    cards.forEach(function (card) {
      var i = Number(card.dataset.i);
      var s = STORES[i];

      /* In distance mode, show all stores */
      card.hidden = false;
      card.classList.remove('is-active');

      /* Re-add marker to map */
      var m = markerByIndex.get(i);
      if (m) m.addTo(map);

      var badge = card.querySelector('.store-locator__card-distance');
      if (!badge) return;

      if (s && s._dist !== Infinity) {
        var dist = s._dist;
        badge.textContent = dist < 10
          ? dist.toFixed(1) + ' km'
          : Math.round(dist) + ' km';
        badge.hidden = false;
      } else {
        badge.hidden = true;
      }
    });

    /* Hide empty state */
    if (emptyEl) emptyEl.classList.remove('is-visible');

    /* Sort cards by distance (nearest first) */
    var sorted = cards.slice().sort(function (a, b) {
      /* Not `|| Infinity` — a store 0 km away must sort first, not last */
      var da = STORES[Number(a.dataset.i)]._dist;
      var db = STORES[Number(b.dataset.i)]._dist;
      if (typeof da !== 'number') da = Infinity;
      if (typeof db !== 'number') db = Infinity;
      return da - db;
    });

    sorted.forEach(function (card) {
      listEl.appendChild(card);
    });

    /* Show user marker on map */
    showUserMarker(lat, lng);

    /* Zoom map to user + nearest 3 stores */
    suppressAutoFit(0);
    selectedIndex = null;
    var bounds = L.latLngBounds([]);
    bounds.extend([lat, lng]);
    var nearest = sorted.slice(0, 3);
    nearest.forEach(function (c) {
      var m = markerByIndex.get(Number(c.dataset.i));
      if (m) bounds.extend(m.getLatLng());
    });
    if (bounds.isValid()) map.fitBounds(bounds, { padding: [40, 40] });
  }

  /**
   * Clear distance sorting and badges.
   */
  function clearDistances() {
    currentUserLat = null;
    currentUserLng = null;
    isDistanceMode = false;

    cards.forEach(function (card) {
      var badge = card.querySelector('.store-locator__card-distance');
      if (badge) badge.hidden = true;
    });

    STORES.forEach(function (s) { delete s._dist; });

    if (userMarker) {
      map.removeLayer(userMarker);
      userMarker = null;
    }
  }

  /* ── Geolocation (GPS) ── */
  if (locateBtn) {
    locateBtn.addEventListener('click', function () {
      if (!navigator.geolocation) {
        alert('Din browser understøtter ikke placering.');
        return;
      }

      locateBtn.classList.add('is-loading');

      navigator.geolocation.getCurrentPosition(
        function (pos) {
          locateBtn.classList.remove('is-loading');
          var lat = pos.coords.latitude;
          var lng = pos.coords.longitude;

          applyDistances(lat, lng);

          /* Reverse geocode to show the user's address in the input */
          var revUrl = 'https://nominatim.openstreetmap.org/reverse?format=json&addressdetails=1&lat=' + lat + '&lon=' + lng;
          fetch(revUrl, { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (data) {
              if (data && data.address) {
                var a = data.address;
                var road = a.road || '';
                var postCity = [a.postcode, a.town || a.village || a.suburb || a.city || ''].filter(Boolean).join(' ');
                var display = [road, postCity].filter(Boolean).join(', ');
                if (inputEl && display) inputEl.value = display;
              }
            })
            .catch(function () { /* silent – distances already applied */ });
        },
        function (err) {
          locateBtn.classList.remove('is-loading');
          if (err.code === 1) {
            alert('Du har afvist deling af din placering. Tillad det i din browsers indstillinger.');
          } else {
            alert('Kunne ikke finde din placering. Prøv igen.');
          }
        },
        { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 }
      );
    });
  }

  /* ── Nominatim autocomplete ── */
  var geocodeTimer = null;
  var lastQuery = '';
  var suggestionsEl = document.getElementById('storeSuggestions');
  var focusedIdx = -1;
  var POSTCODE_RE = /^\d{4}$/;

  function hideSuggestions() {
    if (!suggestionsEl) return;
    suggestionsEl.hidden = true;
    suggestionsEl.innerHTML = '';
    focusedIdx = -1;
  }

  /**
   * Format a Nominatim result into a clean Danish address.
   * Shows: "Vej 8, 4340 Holbæk" — no municipality, region, or country.
   */
  function formatAddress(r) {
    var a = r.address || {};
    var street = '';
    if (a.road) {
      street = a.road;
      if (a.house_number) street += ' ' + a.house_number;
    }
    var postCity = [a.postcode, a.town || a.village || a.suburb || a.city || ''].filter(Boolean).join(' ');
    var main = street || a.neighbourhood || a.suburb || postCity;
    var sub = street ? postCity : '';
    return { main: main, sub: sub, full: [street, postCity].filter(Boolean).join(', ') };
  }

  var NO_RESULTS_MSG = 'Vi kunne ikke finde adressen. Prøv et andet postnummer eller en anden adresse.';
  var ERROR_MSG = 'Søgningen fejlede. Prøv igen om lidt.';

  /* Non-selectable info line in the dropdown (no results / error) */
  function showMessage(text) {
    if (!suggestionsEl) return;
    focusedIdx = -1;
    suggestionsEl.innerHTML = '<li class="store-locator__suggestion-message" role="status">' + text + '</li>';
    suggestionsEl.hidden = false;
  }

  function showSuggestions(results) {
    if (!suggestionsEl) return;
    if (!results || results.length === 0) {
      showMessage(NO_RESULTS_MSG);
      return;
    }

    focusedIdx = -1;
    suggestionsEl.innerHTML = results.map(function (r, i) {
      var addr = formatAddress(r);

      return '<li class="store-locator__suggestion" role="option" data-lat="' +
        r.lat + '" data-lng="' + r.lon + '" data-idx="' + i + '" data-name="' +
        addr.full.replace(/"/g, '&quot;') + '">' +
        '<span class="store-locator__suggestion-main">' + addr.main + '</span>' +
        (addr.sub ? ' <span class="store-locator__suggestion-sub">' + addr.sub + '</span>' : '') +
        '</li>';
    }).join('');

    suggestionsEl.hidden = false;
  }

  function selectSuggestion(li) {
    var lat = parseFloat(li.getAttribute('data-lat'));
    var lng = parseFloat(li.getAttribute('data-lng'));
    var name = li.getAttribute('data-name');

    /* Fill input with selected address */
    if (inputEl) inputEl.value = name;

    hideSuggestions();

    if (!isNaN(lat) && !isNaN(lng)) {
      applyDistances(lat, lng);
    }
  }

  function updateFocus() {
    if (!suggestionsEl) return;
    var items = suggestionsEl.querySelectorAll('.store-locator__suggestion');
    items.forEach(function (li, i) {
      li.classList.toggle('is-focused', i === focusedIdx);
    });
  }

  function selectFirstSuggestion() {
    if (!suggestionsEl) return;
    var first = suggestionsEl.querySelector('.store-locator__suggestion');
    if (first) selectSuggestion(first);
  }

  /* Promise cache per query — shared by typing, postcode auto-select and Enter */
  var geocodeCache = {};

  function geocode(q) {
    if (geocodeCache[q]) return geocodeCache[q];

    var url = 'https://nominatim.openstreetmap.org/search?format=json&addressdetails=1&limit=5&countrycodes=dk&q=' + encodeURIComponent(q);

    geocodeCache[q] = fetch(url, {
      headers: { 'Accept': 'application/json' }
    })
    .then(function (r) {
      if (!r.ok) throw new Error('Geocoding failed: ' + r.status);
      return r.json();
    })
    .catch(function (err) {
      delete geocodeCache[q];
      throw err;
    });

    return geocodeCache[q];
  }

  /**
   * Look up suggestions for the query. With autoSelect, the first result is
   * selected right away so the list gets sorted by distance.
   */
  function fetchSuggestions(query, autoSelect) {
    var q = (query || '').trim();
    if (q.length < 3) { hideSuggestions(); return; }

    if (q === lastQuery && !autoSelect) return;
    lastQuery = q;

    geocode(q)
    .then(function (results) {
      /* Only show if input still matches (prevent stale results) */
      if (!inputEl || inputEl.value.trim() !== q) return;
      showSuggestions(results);
      if (autoSelect) selectFirstSuggestion();
    })
    .catch(function () {
      lastQuery = '';
      if (inputEl && inputEl.value.trim() === q) showMessage(ERROR_MSG);
    });
  }

  /* ── Suggestion click handler ── */
  if (suggestionsEl) {
    suggestionsEl.addEventListener('click', function (e) {
      var li = e.target.closest('.store-locator__suggestion');
      if (li) selectSuggestion(li);
    });
  }

  /* ── Address search (geocoding only, no text filtering) ── */
  function showAllCards() {
    cards.forEach(function (card) {
      card.hidden = false;
      card.classList.remove('is-active');
      var m = markerByIndex.get(Number(card.dataset.i));
      if (m) m.addTo(map);
    });
    if (emptyEl) emptyEl.classList.remove('is-visible');
  }

  if (inputEl) {
    inputEl.addEventListener('input', function () {
      clearTimeout(geocodeTimer);
      var q = inputEl.value.trim();

      if (POSTCODE_RE.test(q)) {
        /* Complete postcode: pick the first result automatically */
        geocodeTimer = setTimeout(function () { fetchSuggestions(q, true); }, 250);
      } else if (q.length >= 3) {
        geocodeTimer = setTimeout(function () { fetchSuggestions(q); }, 400);
      } else {
        hideSuggestions();
        if (q.length === 0) {
          clearDistances();
          showAllCards();
          lastQuery = '';
          suppressAutoFit(0);
          selectedIndex = null;
          fitDefaultView();
        }
      }
    });

    /* Keyboard navigation */
    inputEl.addEventListener('keydown', function (e) {
      var items = (suggestionsEl && !suggestionsEl.hidden)
        ? suggestionsEl.querySelectorAll('.store-locator__suggestion')
        : [];

      if (e.key === 'Enter') {
        e.preventDefault();
        if (focusedIdx >= 0 && items[focusedIdx]) {
          selectSuggestion(items[focusedIdx]);
        } else {
          /* No highlighted suggestion: geocode current text and pick the first hit */
          clearTimeout(geocodeTimer);
          fetchSuggestions(inputEl.value, true);
        }
        return;
      }

      if (e.key === 'Escape') {
        hideSuggestions();
        return;
      }

      if (!items.length) return;

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        focusedIdx = Math.min(focusedIdx + 1, items.length - 1);
        updateFocus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        focusedIdx = Math.max(focusedIdx - 1, 0);
        updateFocus();
      }
    });

    /* Close suggestions on outside click */
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.store-locator__search-wrap')) {
        hideSuggestions();
      }
    });
  }
})();
